<template>
  <footer class="footer-container bg-img desktop-footer" style="">
    <div class="columns is-12 is-mobile is-tablet is-desktop">
      <div class="column is-3-desktop is-3-tablet is-hidden-mobile" style="text-align:left; display: flex; flex-direction: column; justify-content: space-between;">
        <h1 class="pb-title color-white mb-1">{{statistic.career_title}}</h1>
        <div class="" style="white-space: nowrap;">
          <div class="pb-3">
            <span class="footer-subtitle">Follow us at:</span><br>
          </div>
          <span>
            <a href="https://www.facebook.com/AHAMPB/" target="_blank">
              <img src="../assets/img/facebook-latest_icon.png"  style="width:30px; height:30px; margin-right: 1rem;" />
            </a>
          </span>
          <span>
            <a href="https://www.instagram.com/aham_pb/" target="_blank">
              <img src="../assets/img/ig.svg" style="width:30px; height:30px; margin-right: 1rem;" />
            </a>
          </span>
          <span>
            <a href="https://www.youtube.com/@ahampb" target="_blank">
              <img src="../assets/img/youtube-icon.png" style="width:30px; height:30px; margin-right: 1rem;" />
            </a>
          </span>
          <span>
            <a href="https://www.linkedin.com/company/aham-capital-partnership-business/" target="_blank">
              <img src="../assets/img/linkedin-icon.png" style="width:30px; height:30px;" />
            </a>
          </span>
        </div>
        <div class="">
          <img src="../assets/img/aham-wp-logo-white.svg" style="max-width: 80%; height: 38px"/>
        </div>
      </div>

      <div class="column is-5-desktop is-5-tablet is-hidden-mobile has-text-left middle-column" style="color: #fff; text-align:left; display: flex; flex-direction: column; justify-content: space-between;">
        <div>
          <p class="footer-subtitle">Head Office</p>
          <p class="footer-title">Ground Floor, Menara Boustead, 69, Jalan Raja Chulan, 
            Bukit Ceylon, 50200 Kuala Lumpur, Wilayah Persekutuan 
            Kuala Lumpur.</p>
        </div>
        <div style="margin-top: 1.35rem" >
          <p class="footer-subtitle">PJ Branch</p>
          <p class="footer-title">C-31-1, Jaya One, 72A Jalan Prof Diraja Ungku Aziz,
            Section 13, 46200 Petaling Jaya, Selangor.</p>
        </div>
        <div class="mr-0 is-flex flex-tablet" style="margin-top: 1.35rem" >
          <div class="parasupport-box">
            <p class="footer-subtitle">Parasupport</p>
            <a class="footer-title" style="color: #fff;" href="tel:+4733378901">1800-22-2288 </a>
          </div>
          <div>
            <p class="footer-subtitle">Email Us</p>
            <a class="footer-title" style="color: #fff;" href="mailto:parasupport@aham.com.my">parasupport@aham.com.my</a>
          </div>
        </div>
        <div class="mb-1 mr-0 footer-title" style="margin-top: 1.35rem">
          Copyright © {{ new Date().getFullYear() }} AHAM Asset Management Berhad
        </div>
      </div>

      <!-- <div class="column is-2-desktop is-hidden-touch has-text-left"  style="color: #fff; text-align:left; display: flex; flex-direction: column; justify-content: space-between;">
        <div v-for="footer,index in menu" :key="index">
          <router-link :to="{ name: footer.path}" class="footer-subtitle">
            {{footer.label}}
          </router-link>
        </div>
      </div> -->

      <div class="column is-4-desktop is-4-tablet is-hidden-mobile has-text-left last-column" style=" text-align:left; display: flex; flex-direction: column; justify-content: space-between;" >
        <p class="footer-subtitle">Important Information</p>
        <div class="" v-for="item,index in copyright" :key="index" >
          <a :href="item.url" class="footer-title">{{item.title}}</a>
        </div>
      </div>
      <!-- Mobile version -->
      <div class="is-hidden-desktop is-hidden-tablet" style="width: 100%;">
        <div class="column">
          <img class="footer-logo" src="../assets/img/aham-wp-logo-white.svg" />
        </div>
        <div style="margin-top: 1.25rem;">
          <div class="footer-slogan color-white has-text-left">{{statistic.career_title}}</div>
        </div>
        <!-- Mobile: Address, contact, email, social media -->
        <div style="margin-top: 1.25rem;">
          <div class="mb-3">
            <span class="footer-mobile-label">Follow us at:</span><br>
          </div>
          <span><a href="https://www.facebook.com/AHAMPB/" target="_blank"><img src="../assets/img/facebook-latest_icon.png"  style="width:30px; height:30px; margin-right: 1.25rem;" /></a></span>
          <span><a href="https://www.instagram.com/aham_pb/" target="_blank"><img src="../assets/img/ig.svg" style="width:30px; height:30px; margin-right: 1.25rem;" /></a></span>
          <span><a href="https://www.youtube.com/@ahampb" target="_blank"><img src="../assets/img/youtube-icon.png"   style="width:30px; height:30px; margin-right: 1.25rem;" /></a></span>
          <span><a href=" https://www.linkedin.com/company/aham-capital-partnership-business/" target="_blank"><img src="../assets/img/linkedin-icon.png"   style="width:30px; height:30px;" /></a></span>
        </div>
        <div style="margin-top: 1.25rem;" >
          <div style="max-width: 500px;">
            <p class="footer-subtitle">Head Office</p>
            <p class="footer-title">Ground Floor, Menara Boustead, <br> 69, Jalan Raja Chulan, 
              Bukit Ceylon, 50200 Kuala Lumpur, Wilayah Persekutuan 
              Kuala Lumpur.</p>
          </div>
          <div style="margin-top: 0.625rem; max-width: 500px;" >
            <p class="footer-subtitle">PJ Branch</p>
            <p class="footer-title">C-31-1, Jaya One, <br> 72A Jalan Prof Diraja Ungku Aziz,
              Section 13, 46200 Petaling Jaya, Selangor.</p>
          </div>
          <div style="margin-top: 1rem" >
            <div>
              <p class="footer-subtitle">Parasupport</p>
              <a class="footer-title" style="color: #fff;" href="tel:+4733378901">1800-22-2288 </a>
            </div>
          </div>
          <div style="margin-top: 1rem" >
            <div>
              <p class="footer-subtitle">Email Us</p>
              <a class="footer-title" style="color: #fff;" href="mailto:parasupport@aham.com.my">parasupport@aham.com.my</a>
            </div>
          </div>
        </div>
        <!-- <div class="columns is-hidden-desktop is-multiline is-mobile m-0 mt-6">
          <div class="column is-half" v-for="footer,index in menu" :key="index">
            <router-link :to="{ name: footer.path}" class="footer-subtitle">
              {{footer.label}}
            </router-link>
          </div>
        </div> -->
        <!-- Mobile: Copyright -->
        <div style="margin-top: 1.25rem;" >
          <p class="footer-subtitle">Important Information</p>
          <div v-for="item,index in copyright" :key="index">
            <div style="margin-top: 1rem;">
              <a class="footer-title" :href="item.url">{{item.title}}</a>
            </div>
          </div>
          <div class="color-white" style="margin-top: 1.25rem;">Copyright © {{ new Date().getFullYear() }} AHAM Asset Management Berhad</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import store from '../store';

  export default {
    data() {
      return {
        copyright: [
          {
            title: 'Anti-Bribery & Anti-Corruption',
            url: 'https://aham.com.my/anti-bribery-anti-corruption'
          },
          {
            title: 'Anti-Money Laundering &\n Anti-Terrorism Financing',
            url: 'https://aham.com.my/anti-money-laundering-anti-terrorism-financing'
          },
          {
            title: 'Compliance',
            url: 'https://aham.com.my/compliance'
          },
          {
            title: 'Disclaimer',
            url: 'https://aham.com.my/disclaimer'
          },
          {
            title: 'Internet Risk',
            url: 'https://aham.com.my/internet-risk'
          },
          {
            title: 'Privacy Notice',
            url: 'https://aham.com.my/privacy-notice'
          },
          {
            title: 'SIDREC',
            url: 'https://sidrec.com.my/'
          },
          {
            title: 'Terms and Conditions',
            url: 'https://aham.com.my/terms-and-conditions'
          }
        ],
        menu: [
          {
            label: 'Insights',
            path: 'index'
          },
          {
            label: 'Happenings',
            path: 'happenings'
          },
          {
            label: 'Resources',
            path: 'main'
          },
          {
            label: 'Career',
            path: 'careers'
          },
          {
            label: 'About Us',
            path: 'about-us'
          },
          {
            label: 'Contact Us',
            path: 'contact-us'
          },
        ],
        statistic: []
      };
    },
    mounted() {
      this.$httpClientCMS({       // GET statistic data
        method: 'GET',
        url: 'api/static-fields-homepage'
      })
        .then(resp => {
          let data = resp.data.data.attributes;
          this.$set(this, 'statistic', data);
      })
        .catch((error) => {
          this.$router.push('maintenance');
      });
    },
    computed: {
      companyTel(){
        return this.$store.getters.get_company_tel;
      },
      companyEmail(){
        return this.$store.getters.get_company_email;
      },
      companyAddress(){
        return this.$store.getters.get_company_address;
      },
      companyLogoWhiteMotto(){
        // return this.$store.getters.get_company_logo('white-motto');
        return this.$store.getters.get_company_logo('colored');
      }
    }
  }
</script>

<style scoped lang="scss">
@import '../pages/styles/font.scss';
.footer-logo{
  width: 40%;
}
.title{
  font-weight: 700;
}

.font-size-2 {
  font-size: 16px;
}

.font-weight-1 {
  font-weight: 700;
}

.desktop-footer{
  padding-top: 1.7rem;
  padding-bottom: 1.7rem;
  padding-left: 9.5rem;
  padding-right: 8rem;
}

.middle-column {
  padding-right: 3rem;
}

.parasupport-box {
  margin-right: 4.5rem;
}

.font-weight-2 {
  font-weight: 400;
}
.footer-container {
  background: url('../assets/img/footer.jpg');
  width: 100%;
  overflow: hidden;
}
.footer-nav {
  color: #fff;
  font-weight: 700;
}

// -------------

.footer-bg{
  text-align: left;
  background: url('../assets/img/footer_mobile_red.png');
  color: white;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
}

.footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  overflow-x:hidden !important;
  padding: 10px;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 14px;
}

.hero {
  font-family: 'Open Sans', sans-serif !important;
}

.navbar-end.navbar-item{
  color: #323337;
  font-weight: 500;
  font-size: medium;
}

.top-header{
  font-weight: 600;
  color: #2F469C;
  text-align: right;
  padding: 10px;
  margin-right: 100px;
}

.footer-link{
  color: white;
  line-height: 20px;
}

.dropdown + .dropdown{
  margin-left: 0px;
}

.navbar-item, .navbar-link{
  padding-right: 0px;
  padding-left: 0px;
  height: 0px;
}

.button.is-ghost, a.navbar-item, .navbar-link {
  color: #323337;
  font-weight: 500;
  background: transparent;
  font-size: medium;
}

.button.is-ghost:hover, a.navbar-item, .navbar-link {
  color: #2F469C;
}

.dropdown{
  text-align: left !important;
}

.navbar-end.dropdown-menu.dropdown-content{
  background-color: #F3F3F3 !important;
}

.footer-mobile:hover{
  text-decoration-line: underline;
}

.footer-text, .footer-mobile, .footer-mobile-label{
  background: transparent;
  color: #fff;
  font-weight: 700;
}

// @media screen and (min-width:2420px) {
//   .followUs-col{
//     padding-left: 135px !important;
//   }
// }

// @media screen and (max-width:2419px) and (min-width:2260px) {
//   .followUs-col{
//     padding-left: 110px !important;
//   }
// }

// @media screen and (max-width:2259px) and (min-width:1990px) {
//   .followUs-col{
//     padding-left: 90px !important;
//   }
// }

// @media screen and (max-width:1989px) and (min-width:1810px) {
//   .followUs-col{
//     padding-left: 70px !important;
//   }
// }

// @media screen and (max-width:1809px) and (min-width:1410px) {
//   .followUs-col{
//     padding-left: 50px !important;
//   }
// }

@media (min-width: 1661px){
  .desktop-footer{
    padding-left: 9.5rem;
    padding-right: 4rem;
  }

  // .last-column {
  //   // padding-right: 5rem;
  // }

  .middle-column {
    padding-right: 4.5rem;
  }

  .parasupport-box {
    margin-right: 5.5rem;
  }
}

@media (min-width: 1408px) and (max-width: 1660px){
  .desktop-footer{
    padding-top: 2rem;
    padding-left: 7.5rem;
    padding-right: 5rem;
  }
}

@media (min-width: 1216px) and (max-width: 1407px){
  .desktop-footer{
    padding-top: 2rem;
    padding-left: 6.5rem;
    padding-right: 3rem;
  }

  .middle-column {
    padding-right: 2rem;
  }
}

@media (min-width: 769px) and (max-width: 1215px){
  .desktop-footer{
    padding-top: 2rem;
    padding-bottom: 2rem;
    padding-left: 6.5rem;
    padding-right: 1rem;
  }

  .middle-column {
    padding-right: 1rem;
  }

  .parasupport-box {
    margin-right: 2rem;
  }
}


@media screen and (max-width:1224px) {
  .contact-column, .email-column{
    margin-left: 10px !important;
  }
}

@media (min-width: 768px) and (max-width:1023px) {
  .footer-container {
    background-position: 10%;
    padding: 1.55rem 2rem;
  }

  .flex-tablet {
    display: block !important;
  }

  .parasupport-box {
    margin-right: 0;
    margin-bottom: 1rem;
  }
}

@media screen and (max-width: 768px) {
  .footer-container {
    background: url('../assets/img/footer_mobile_red.png');
    background-position: top right;
    background-repeat: no-repeat;
    padding: 1.55rem 1.2rem;
    text-align: left;

    .columns {
      margin: 0;
      padding: 0;

      .column {
        margin: 0;
        padding: 0;
      }
    }
  }

  .footer-logo {
    width: 244px;
  }
}

// @media screen and (max-width:1023px) and (min-width:768px) {
//   .footer-text, .footer-mobile, .footer-mobile-label{
//     font-size: 24px;
//   }

//   // .footer-container {
//   //   background: url('../assets/img/footer_mobile_red.png');
//   //   background: none;
//   //   background-repeat: no-repeat;
//   // }
  

//   // .desktop-footer{
//   //   padding: 0;
//   // }
// }

// @media screen and (max-width:767px){
//   .top-header{
//     margin-right: 0px !important;
//   }

//   // .desktop-footer{
//   //   padding: 0;
//   // }

//   .navbar{
//     padding-left: 10px !important;
//     padding-right: 0px !important;
//   }

//   .is-hidden-desktop.navbar-item{
//     margin-left: 300px !important;
//   }

//   .hero-body{
//     padding-right: 10px !important;
//   }

//   .footer-text, .footer-mobile, .footer-mobile-label{
//     font-size: 16px;
//   }
// }

// @media screen and (max-width:425px){
//   .footer-text, .footer-mobile, .footer-mobile-label{
//     font-size: 14px !important;
//   }

//   // .desktop-footer{
//   //   padding: 0 !important;
//   // }

//   .footer-logo{
//     width: 60%;
//   }

//   .address-text{
//     max-width: 100%;
//   }
// }
</style>
